import { useEffect } from 'react';
import { useErrorPageContext } from './CustomPageErrorProvider';
import errorCodes from '../../../data/translations/errorCodes';
import { useTranslationAPI } from '../../translations';

function PageNotFound() {
	const { setRouteError } = useErrorPageContext();
	const { translate } = useTranslationAPI();

	useEffect(() => {
		setRouteError({
			statusCode: 404,
			title: translate(errorCodes.pageNotFound),
			description: translate(errorCodes.pageNotFoundDescription),
		});
	}, [setRouteError, translate]);

	return null;
}

export { PageNotFound };
